export const tabs = ["details", "tools", "users", "costs", "history"];
